import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, Output, EventEmitter, OnChanges, HostListener, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CdkDragDrop, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { first, Subject, Subscription, EMPTY, TimeoutError } from 'rxjs';
import { switchMap, take, catchError, timeout } from 'rxjs/operators';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';

import { ApiResponse } from '@app/_models';
import { SpringQuery } from '@app/_helpers/spring-query';
import { ConstantService, DataCacheService } from '@app/_services';
import { PictureService } from '@app/_components/picture/picture.service';
import { Image } from '..'
import { PropertyImageComponent } from '../property-image.component/property-image.component';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-property-image-vert-layout',
    templateUrl: './property-image-vert-layout.component.html',
    styleUrls: ['./property-image-vert-layout.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    standalone: false
})
export class PropertyImageVertLayoutComponent implements OnInit, OnDestroy {
	@ViewChild('captionarea') captionArea: any;
	@ViewChild('dropContainer') dropContainerEl: ElementRef<HTMLElement>;
	@ViewChildren(CdkDrag) dragItems: QueryList<CdkDrag>;
	count: number;
	pictureProperties: any = {};
	pictureData: any;
    pictureIndex: number;
	mediaTypes: any[]=[];

	constructor(
		private pictureService: PictureService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private formBuilder: UntypedFormBuilder,
		private messageService: MessageService,

		private constantService: ConstantService,
		private dataCacheService: DataCacheService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private location: Location,

	) {
		// proprietary helpers
		this.describeTypes = this.constantService.describeTypes;
		this.developmentSummaries = this.dataCacheService.developmentSummaries;
		this.shortTermRentalSummaries = this.dataCacheService.shortTermRentalSummaries;
		this.mediaTypes = this.pictureService.mediaTypes;
				console.log('this.shortTermRentalSummaries ' + JSON.stringify(this.shortTermRentalSummaries));

	}

	@Input() imageId: number;
	@Input() images: any[] = [];
		
	// input objects
	@Input() shortTermRentalId: number;
	@Input() developmentId: number;
	@Input() propertyFeatureId: number;
	@Input() guestBookId: number;


	// forms
	formLoading = false;
	addForm: UntypedFormGroup;
	editForm: UntypedFormGroup;
	checked: boolean = false;

	// data
	uploadedFiles: any[] = [];
	pictureArray: any[] = [];
	pictures: any[] = [];
	image: Image;
	forDeletePictures: any[] = [];


	// Subject that feeds switchMap so every new drop cancels any previous
	// in-flight sort request. A slow response from an earlier drop can never
	// overwrite the order the user put in place with a later drop.
	private sortRequest$ = new Subject<any[]>();
	private sortSubscription: Subscription;

	// Set to true the moment the user performs a drag-drop reorder.
	// While true, loadLazy() will NOT reset this.images from server data —
	// this prevents the Edit Media table's filter/sort events from snapping
	// the Sort Media grid back to server order (Emily Butterfield bug, 2026-05-07).
	// Cleared after a successful sort save so the next loadLazy can re-sync.
	private userHasSortedImages: boolean = false;

	// datalist
	lazyLoadEvent: LazyLoadEvent;
	recordTotal: number = 0;
	loading = true;
	multiSortMeta = [];
	first = 0;
	rows = 50;

	closePreviewWindow = false;

	columns: any[] = [
		{ field: 'describeTypes', header: 'Describe Types', width: 'auto' },
		{ field: 'caption', header: 'Caption', width: 'auto' },
		{ field: 'propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'adrDevelopmentName', header: 'Address Development Name', width: 'auto' },
		{ field: 'sortOrder', header: 'sortOrder', width: 'auto' },
		{ field: 'slPictureId', header: 'SL Picture ID', width: 'auto' },
		{ field: 'pictureId', header: 'pictureId', width: 'auto' },
	];

	validationMessages:
		{
			pictureId: [{ type: 'required', message: 'Required' }],
			createDate: [{ type: 'required', message: 'Required' }],
			lastUpdate: [{ type: 'required', message: 'Required' }],
		}


	// proprietary helpers
	describeTypes: any[];
	developmentSummaries: any[];
	shortTermRentalSummaries: any[];


	getDescribeTypeName(describeType: any) {
		return this.describeTypes.find(i => i.code === describeType)?.name;
	}

	getShortTermRentalPropertyCode(shortTermRentalId: any) {
		console.log('shortTermRentalId ' + shortTermRentalId);
		/*console.log('this.shortTermRentalSummaries1 ' + JSON.stringify(this.shortTermRentalSummaries));*/
		return this.shortTermRentalSummaries.find(i => i.shortTermRentalId === shortTermRentalId)?.propertyCode;
	}

	getDevelopmentName(developmentId: any) {
		// console.log('dodod' + developmentId);
		return this.developmentSummaries.find(i => i.developmentId === developmentId)?.addressDevelopmentName;
	}


	ngOnInit(): void {
		// NOTE: Do NOT call fetchPictures() here.
		// The PrimeNG p-table fires (onLazyLoad) on first render, which calls loadLazy()
		// and populates both this.pictures and this.images. Calling fetchPictures() here
		// too creates two concurrent GET /pictures requests on every component init.
		// If either fails, the user sees duplicate "Media load failed" toasts before any
		// upload is attempted. The table's onLazyLoad is the single source of truth for
		// the initial load. fetchPictures() is retained as a fallback for when
		// lazyLoadEvent is not yet set (e.g. the table hasn't fired its first event yet).

		// default sort of list
		this.multiSortMeta = [];
		this.multiSortMeta.push({ field: 'createDate', order: 0 });

		// Wire up the sort-request pipeline. switchMap cancels any in-flight sort
		// request when a new drag completes, so a slow/retried response from an earlier
		// drag can never overwrite the order that a later drag already put in place.
		this.sortSubscription = this.sortRequest$.pipe(
			switchMap(pictureArray => this.pictureService.sortPictureOrder(pictureArray).pipe(
				// catchError INSIDE switchMap so a failed sort request does not kill the
				// outer subscription. Without this, the first HTTP error from sortPictureOrder
				// propagates through switchMap and terminates the subscription permanently —
				// all subsequent drags would call sortRequest$.next() with no subscriber
				// listening, silently discarding every sort save after the first failure.
				catchError(err => {
					console.log('Update picture sort order FAIL:', err);
					const sortMsg = typeof err === 'string' ? err : (err?.message || err?.error?.message || 'Sort update failed');
					this.messageService.add({ severity: 'error', summary: 'Error', detail: sortMsg });
					// Return EMPTY so switchMap continues waiting for the next drag event.
					return EMPTY;
				})
			))
		).subscribe({
			next: res => {
				// The UI already shows the correct order (dragEntered called moveItemInArray
				// optimistically). Just sync the sortOrder field on each picture object
				// in-place so the Edit table column stays accurate — do NOT replace the
				// array reference, which would reset the visible drag order.
				if (res?.data?.pictures) {
					res.data.pictures.forEach((updated: any) => {
						const local = this.pictures.find(p => p.pictureId === updated.pictureId);
						if (local) { local.sortOrder = updated.sortOrder; }
					});
					// Keep images array sortOrder in sync too
					res.data.pictures.forEach((updated: any) => {
						const local = this.images.find(p => p.pictureId === updated.pictureId);
						if (local) { local.sortOrder = updated.sortOrder; }
					});
				}
				// Sort successfully persisted to server — clear the flag so the next
				// loadLazy() call (e.g. after upload or delete) can refresh Sort Media.
				this.userHasSortedImages = false;
				this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, sticky: false });
			}
		});
	}

	ngOnDestroy(): void {
		this.sortSubscription?.unsubscribe();
		this.sortRequest$.complete();
	}


	/********** Update Image in DB **********/
	formUpdate(image: any) {
		try {
			console.log('Image : ' + JSON.stringify(image));
			this.formLoading = true;
			this.pictureService.update(image)
				.subscribe(
					res => {
						console.log('formUpdate SUCCESS: ' + JSON.stringify(res));
						this.pictures.map((image, i) => {
							if (image.pictureId === res.data.picture.pictureId) {
								this.pictures[i] = res.data.picture;
							}
						});
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					err => {
						console.log('formUpdate FAIL: ' + JSON.stringify(err));
						const msg = typeof err === 'string' ? err : (err?.message || err?.error?.message || 'Unknown error');
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Update failed: ' + msg, sticky: true });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
		}
	}
//this.activities.splice(this.activities.indexOf(activity), 1);

	/********** Delete Image from DB + S3 **********/
	onDelete(image) {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + image.pictureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				try {
					this.formLoading = true;
					this.pictureService.removePicture(image.pictureId)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								this.pictures.splice(this.pictures.indexOf(image), 1);
								// Reset flag so fetchPictures() will refresh Sort Media from server.
								this.userHasSortedImages = false;
								this.images = [...this.pictures];
								this.recordTotal = this.pictures.length;
								this.fetchPictures();
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err, sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}
	
	/********** Delete Image from DB + S3 **********/
	deleteMultiplePictures() {
		try {
					this.formLoading = true;
					this.pictureService.removeMultiplePicture(this.forDeletePictures)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								this.forDeletePictures = [];
								// Reset flag so fetchPictures() will refresh Sort Media from server.
								this.userHasSortedImages = false;
								this.fetchPictures();
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + (err?.error?.message || err?.message || 'Unknown error'), sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
	}


	/********** Load Images from DB **********/
	loadLazy(event: LazyLoadEvent) {
		// Guard: PrimeNG may pass undefined on first render or when called before
		// the table fires its first onLazyLoad event (e.g. from uploadPicture).
		if (!event || event.rows == null) {
			this.fetchPictures();
			return;
		}
		try {
			this.formLoading = true;
			this.lazyLoadEvent = event;
			const pageNumber = Math.round(event.first / event.rows);

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			// If we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			let springQuery = new SpringQuery();
			springQuery.addEquals('size', '200');
			if (this.developmentId) {
				springQuery.addEquals('developmentVO.developmentId', this.developmentId.toString())
			}
			if (this.shortTermRentalId) {
				springQuery.addEquals('shortTermRentalVO.shortTermRentalId', this.shortTermRentalId.toString())
			}

			this.pictureService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters,
				springQuery).pipe(first()).subscribe(

					res => {
						if (!res) { this.formLoading = false; return; }
						this.pictures = res.data?.pictures ?? [];
						for (var index in this.pictures) {
							this.pictures[index].checked = false;
						}
						this.pictures.sort((t1, t2) => {
							if (t1.sortOrder > t2.sortOrder) {
								return 1;
							}

							if (t1.sortOrder < t2.sortOrder) {
								return -1;
							}

							return 0;
						});
						// Only reset the Sort Media grid (this.images) from server data if
						// the user has NOT manually reordered photos via drag-drop.
						// When userHasSortedImages is true, a table filter/sort in the Edit
						// Media section fired this loadLazy — we must NOT overwrite the user's
						// manual arrangement in the Sort Media grid above.
						if (!this.userHasSortedImages) {
							this.images = [...this.pictures];
						}
						this.recordTotal = Number(res?.page?.recordTotal) || 0;
						this.formLoading = false;
					},
					err => {
						console.log('Load FAIL:', err);
						this.formLoading = false;
						this.recordTotal = this.recordTotal || 0;
						// After error.interceptor.ts processes the response, err may be a plain
						// string (the server message) rather than an HttpErrorResponse.
						const detail = typeof err === 'string' ? err
							: (err?.message || err?.error?.message || 'Media load failed');
						this.messageService.add({ severity: 'error', summary: 'Error', detail, sticky: true });
					},
					() => { this.formLoading = false; }
				);

		} catch (error) {
			this.formLoading = false;
			this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.message || 'Unknown error', sticky: true });
		}
	}





	// hangover - may not use but has the new SpringQuery setup
	fetchPictures() {
		let springQuery = new SpringQuery();
		springQuery.addEquals('size', '300');
		if (this.developmentId) {
			springQuery.addEquals('developmentVO.developmentId', this.developmentId.toString())
		}
		if (this.shortTermRentalId) {
			springQuery.addEquals('shortTermRentalVO.shortTermRentalId', this.shortTermRentalId.toString())
		}

		this.pictureService.findBySpringQuery(springQuery).pipe(first()).subscribe(

			res => {
				if (!res) { this.formLoading = false; return; }
				this.pictures = res.data?.pictures ?? [];
				this.pictures.sort((t1, t2) => {
					if (t1.sortOrder > t2.sortOrder) {
						return 1;
					}

					if (t1.sortOrder < t2.sortOrder) {
						return -1;
					}

					return 0;
				});
				if (!this.userHasSortedImages) {
					this.images = [...this.pictures];
				}
				this.formLoading = false;
				//console.log("this.picturesthis.pictures :" + this.pictures);
				//this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
			},
			err => {
				console.log('properties list error!:', err);
				const detail = typeof err === 'string' ? err
					: (err?.message || err?.error?.message || 'Media load failed');
				this.messageService.add({ severity: 'error', summary: 'Error', detail });
				// RxJS complete() does NOT fire when error() fires, so formLoading must be
				// cleared here too — otherwise the upload button stays disabled indefinitely
				// after a fetchPictures failure.
				this.formLoading = false;
			},
			() => { this.formLoading = false; }
		);
	}
	
	myUploader(event: any) {
		this.pictureIndex = 0;
		this.uploadedFiles = event.files;
		this.uploadPicture();
	}
	
	uploadPicture() {
		this.formLoading = true;

		const file = this.uploadedFiles[this.pictureIndex];
		const mediaType = this.getMediaType(file); // ⬅ detect image/video

		console.log('Uploading:', file.name, 'mediaType=', mediaType);

		// 5-minute upload timeout. Without this, a stalled S3 upload or slow network
		// leaves formLoading = true indefinitely — the spinner never clears and the
		// upload button stays disabled for hours (Danielle Roel, 2026-05-26).
		const UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

		try {
			this.pictureService.uploadFile(
				file,
				this.shortTermRentalId,
				this.developmentId,
				mediaType
			).pipe(timeout(UPLOAD_TIMEOUT_MS)).subscribe(
				res => {
					this.pictureIndex++;

					if (this.pictureIndex < this.uploadedFiles.length) {
						this.uploadPicture();
					} else {
						// If the table has already fired onLazyLoad, refresh via loadLazy
						// so pagination state is preserved; otherwise fall back to fetchPictures.
						// NOTE: do NOT set formLoading = false here. loadLazy() / fetchPictures()
						// own the formLoading lifecycle: they set it to true on entry and false
						// in their success, error, and complete handlers. Setting formLoading = false
						// here would re-enable the p-fileUpload button while the reload GET is still
						// in flight, allowing a second click that spawns concurrent upload chains —
						// each triggering its own post-upload reload and showing "Media load failed"
						// toasts. formLoading stays true until the full refresh is done.
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Upload All Files Successfully" });
						if (this.lazyLoadEvent) {
							this.loadLazy(this.lazyLoadEvent);
						} else {
							this.fetchPictures();
						}
					}
				},
				err => {
					this.pictureIndex++;
					const isTimeout = err instanceof TimeoutError;
					const detail = isTimeout
						? 'Upload timed out after 5 minutes. Please try again with a smaller file or check your connection.'
						: (err?.error?.message || err?.message || 'Upload failed');

					this.messageService.add({ severity: 'error', summary: 'Error', detail, sticky: true });

					if (this.pictureIndex < this.uploadedFiles.length) {
						this.uploadPicture();
					} else {
						// Reload the table so the user can see what did/didn't upload.
						// formLoading is cleared by loadLazy/fetchPictures when they finish.
						if (this.lazyLoadEvent) {
							this.loadLazy(this.lazyLoadEvent);
						} else {
							this.fetchPictures();
						}
					}
				}
			);
		} catch (error) {
			console.log('Upload error:', error);
			this.formLoading = false;
		}
	}

	
	getUploadUrl() { return `${environment.apiUrl}/pictures/upload`; }

	onBeforeUpload(event: any) {
		this.formLoading = true;
		if (this.developmentId) {
			event.formData.append('developmentId', this.developmentId);
		}
		if (this.shortTermRentalId) {
			event.formData.append('shortTermRentalId', this.shortTermRentalId);
		}
	}
	
	onUpload(event: any) {
		console.log("bbbbbbb : "+JSON.stringify(event));
		this.fetchPictures();
		this.formLoading = false;
		if(event.originalEvent.body.statusCode == 200){
			
			this.messageService.add({ severity: 'success', summary: 'Success', detail: "Upload Image Successfully" });
		}
	}


	@HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
		console.log(event);
		this.closePreviewWindow = !this.closePreviewWindow;
	}



	// Compute the correct drop index for a flex-wrap photo grid using 2D
	// bounding-box math at the moment the mouse is released.
	//
	// Why this is needed: CDK's default "vertical" SingleAxisSortStrategy tracks
	// drop position during the drag using cached clientRects sorted by Y. In a
	// flex-wrap grid this maps every item in the same row to the same Y bucket, so
	// CDK can only distinguish rows — not columns within a row — producing wrong
	// column drops. "mixed" MixedSortStrategy fixes column precision but moves DOM
	// nodes during the drag, which reflows the flex container. After the first
	// cross-row swap the target items shift upward to fill the vacated slot;
	// subsequent elementFromPoint calls land in the newly empty gap below, returning
	// -1, and CDK stops sorting — the drag is stuck after one row.
	//
	// This method bypasses CDK's continuous tracking entirely. At drop time it reads
	// the rendered bounding boxes of all drag items (post-reflow) and finds the item
	// whose center is closest (by Euclidean distance) to the pointer position. That
	// index is authoritative. CDK's event.currentIndex is used only as a fallback
	// when no items are found in the DOM.
	private computeDropIndex(pointerX: number, pointerY: number, excludeIndex: number): number {
		const items = this.dragItems ? this.dragItems.toArray() : [];
		let bestIndex = -1;
		let bestDist = Infinity;
		items.forEach((drag, i) => {
			if (i === excludeIndex) { return; }
			const el = drag.getRootElement() as HTMLElement;
			// getRootElement() always returns the original host element (not the
			// placeholder). Non-dragging items have CSS transforms applied by
			// SingleAxisSortStrategy; getBoundingClientRect() includes those
			// transforms, so we read the correct visual center for each item.
			const rect = el.getBoundingClientRect();
			if (rect.width === 0 && rect.height === 0) { return; } // hidden/placeholder
			const cx = rect.left + rect.width / 2;
			const cy = rect.top + rect.height / 2;
			const dist = Math.hypot(pointerX - cx, pointerY - cy);
			if (dist < bestDist) {
				bestDist = dist;
				bestIndex = i;
			}
		});
		return bestIndex;
	}

	// Single drop handler for the flat cdkDropList. We override CDK's currentIndex
	// with our own 2D bounding-box calculation so cross-row drops land precisely.
	onDrop(event: CdkDragDrop<any[]>): void {
		// Compute the correct target index using pointer position and item rects.
		// event.dropPoint is the pointer position (viewport coordinates) at release.
		// It is a first-class property on CdkDragDrop in CDK 15+.
		const dropPoint: { x: number; y: number } | undefined = (event as any).dropPoint;
		let targetIndex: number;
		if (dropPoint) {
			const computed = this.computeDropIndex(dropPoint.x, dropPoint.y, event.previousIndex);
			targetIndex = computed >= 0 ? computed : event.currentIndex;
		} else {
			targetIndex = event.currentIndex;
		}

		if (event.previousIndex === targetIndex) {
			// No movement — nothing to persist.
			return;
		}
		// Reorder in place. The UI updates instantly (optimistic).
		moveItemInArray(this.images, event.previousIndex, targetIndex);

		// Mark that the user has manually sorted so loadLazy() does not overwrite
		// this.images from server data until the save completes.
		this.userHasSortedImages = true;

		// Build the sort payload from the updated array and push to the switchMap
		// pipeline. Any previous in-flight request is automatically cancelled.
		this.count = 0;
		this.pictureArray = [];
		for (const image of this.images) {
			this.pictureArray.push({
				pictureId: image.pictureId,
				sortOrder: ++this.count
			});
		}
		this.sortRequest$.next(this.pictureArray);
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(picture: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			picture: picture,
			title: 'Edit Picture'
		};
		console.log("gggggggggggg")
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyImageComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateTestCB(data);
				
				this.fetchPictures();

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteTestCB(data);
				
				this.fetchPictures();
				
				// close the dialogBox
				dialogRef.close();
			});
	}

	updateTestCB(picture: Image) {
		console.log('Updating Test: ' + JSON.stringify(picture));
		let itemIndex = this.pictures.findIndex((item: any) => item.pictureId === picture.pictureId);
		this.pictures[itemIndex] = picture;

		// no idea what this is but it is required to update the array
		this.pictures = [...this.pictures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Test ' + picture.pictureId + ' Updated', life: 3000 });
	}

	deleteTestCB(picture: Image) {
		console.log('Removing picture: ' + picture);
		this.pictures.splice(this.pictures.indexOf(picture), 1);
		this.recordTotal = this.pictures.length;

		// no idea what this is but it is required to update the array
		this.pictures = [...this.pictures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Picture ' + picture.pictureId + ' Deleted', life: 3000 });
	}

	addIntoCheckedList(picture: any){
		if (this.forDeletePictures.includes(picture.pictureId)) {
			this.forDeletePictures.splice(this.forDeletePictures.indexOf(picture.pictureId), 1);
		}else{
			this.forDeletePictures.push(picture.pictureId);
		}
		console.log("forDeletePictures : "+this.forDeletePictures);
	}
	
	selectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = true;
			this.forDeletePictures.push(this.pictures[index].pictureId);
		}
		console.log("forDeletePictures after select all : "+this.forDeletePictures);
	}
	
	unSelectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = false;
		}
		console.log("forDeletePictures after deselect all : "+this.forDeletePictures);
	}

	previewVisible: boolean = false;
	currentIndex: number = 0;

	openPreview(index: number): void {
		this.currentIndex = index;
		this.previewVisible = true;
	}

	onVideoContainerClick(event: MouseEvent, index: number): void {
		this.openPreview(index);
		event.stopPropagation();
	}

	onVideoClick(event: MouseEvent, index: number): void {
		this.openPreview(index);
		event.stopPropagation();
		event.preventDefault();
	}

	nextImage(): void {
		if (this.currentIndex < this.images.length - 1) {
			this.currentIndex++;
		}
	}

	prevImage(): void {
		if (this.currentIndex > 0) {
			this.currentIndex--;
		}
	}

	getMediaType(file: File): number {
		if (file.type.startsWith('image/')) {
			return 1; // Image
		} else if (file.type.startsWith('video/')) {
			return 2; // Video
		}
		return 1; // default fallback to image
	}

	isImage(url: string): boolean {
		if (!url) return false;
		const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff'];
		const ext = url.split('.').pop()?.toLowerCase();
		return imageExtensions.includes(ext || '');
	}

	isVideo(url: string): boolean {
		if (!url) return false;
		const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'mkv', 'wmv'];
		const ext = url.split('.').pop()?.toLowerCase();
		return videoExtensions.includes(ext || '');
	}

	getMimeType(url: string): string {
		const ext = url.split('.').pop()?.toLowerCase();

		switch (ext) {
			case 'mp4': return 'video/mp4';
			case 'webm': return 'video/webm';
			case 'mov': return 'video/quicktime';
			case 'avi': return 'video/x-msvideo';
			case 'mkv': return 'video/x-matroska';
			default: return 'video/mp4'; // fallback
		}
	}

	getVideoUrl(fileName: string): string {
		return "https://s3.us-east-1.amazonaws.com/img.kbmhawaii.com-original/"+fileName;
	}





}